import { useState, useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import DropdownSelect from "../../../DropdownSelector";
import { SERVER_URL } from "Util/constants";
import { makeSubmitPuzzleTextRequest } from "API/Puzzles";
import { setPuzzleAndPuzzleType } from "Store/features/puzzleSlice";

import { flipArray } from "Util/validation";
import LoadingScreen from "Containers/Pages/Modal/modals/Login/pages/LoadingScreen";
import { REQUESTS, GAMES_LABELS } from "Util/constants";

import CreateGameOptionButton from "../CreateGameOptionButton";

import "./CollectContentForm.css";
import { setModal, dismissModal } from "Store/features/stateSlice";
import { MODALS } from "Containers/Pages/Modal";

import { encode } from "gpt-tokenizer";

const questionOptions = Array.from({ length: 10 }, (_, i) => i + 1);
const CollectContentForm = (props) => {
  const {
    puzzleType,
    onClickExitCreateGames,
    onUpdateWordsearchSize,
    onCrosswordContent,
    onWordsearchContent,
    onNewsieContent,
    onQuizContent,
  } = props;
  const [isValidContentLength, setIsValidContentLength] = useState(true);
  const [tokensOver, setTokensOver] = useState(0);
  const [questions, setQuestions] = useState(5);

  const dispatch = useDispatch();
  let currentDate = new Date();

  const submitContentRequestStatus = useSelector(
    (state) => state.stateSlice.requests[REQUESTS.SUBMIT_PUZZLE_TEXT]
  );

  const activeModal = useSelector((state) => state.stateSlice.activeModal);

  const authToken = useSelector((state) => state.authSlice.authToken);

  const [title, setTitle] = useState();
  const [date, setDate] = useState(currentDate);

  const [contentText, setContentText] = useState("");

  useEffect(() => {
    const tokens = encode(contentText);
    const totalTokens = 4096 + tokens.length;

    setIsValidContentLength(16385 - totalTokens > 150);
    setTokensOver(totalTokens - (16385 - 150));
    // console.log({ tokens, valid: 16385 - totalTokens > 150 });
  }, [contentText]);

  const handleSelectWordsearchSize = (value) => {
    onUpdateWordsearchSize(value);
  };

  // Puzzle Content Processor
  const processPuzzleContent = useCallback(
    (puzzleType, puzzleContent) => {
      if (puzzleType === "newsie") {
        const flipped = flipArray(puzzleContent.newsieInput);
        onNewsieContent(title, { ...puzzleContent, newsieInput: flipped });
      } else if (puzzleType === "crossword") {
        const trimmedWords = puzzleContent.words.map((word) => ({
          ...word,
          word: word.word.replaceAll(" ", "").toUpperCase(),
        }));
        onCrosswordContent(title, trimmedWords);
      } else if (puzzleType === "wordsearch") {
        onWordsearchContent(
          title,
          puzzleContent?.words?.map((w) => w.toUpperCase())
        );
      } else if (puzzleType === "quiz") {
        onQuizContent(title, puzzleContent);
      }
    },
    [title, onCrosswordContent, dispatch, setPuzzleAndPuzzleType, onQuizContent]
  );

  // Upload Text Via browser
  const submitDynamicCrosswordText = useCallback(async () => {
    try {
      const JSONRES = await makeSubmitPuzzleTextRequest(
        dispatch,
        puzzleType,
        contentText,
        // Number Of Questions
        questions,
        authToken
      );
      const puzzleContent = JSON.parse(JSONRES.content);

      processPuzzleContent(puzzleType, puzzleContent);
    } catch (err) {
      console.log({ err });
    }
  }, [puzzleType, contentText, processPuzzleContent, questions]);

  useEffect(() => {
    if (
      submitContentRequestStatus === "loading" &&
      activeModal !== MODALS.LOADING
    )
      dispatch(setModal(MODALS.LOADING));
    if (
      submitContentRequestStatus === "success" &&
      activeModal === MODALS.LOADING
    )
      dispatch(dismissModal());
  }, [submitContentRequestStatus]);

  return (
    <div className="upload-puzzle-content-container">
      <div className="create-games-container-exit-row-container">
        <div
          className="create-games-screen-exit-button"
          onClick={() => {
            onClickExitCreateGames();
          }}
        >
          X
        </div>
      </div>

      <div className="upload-puzzle-content-form-container">
        <CreateGameOptionButton game={puzzleType} justIcon={true} />
        <h3>Create {GAMES_LABELS[puzzleType.toUpperCase()]} From Content</h3>
        <div className="input-labels-container">
          <div style={{ textAlign: "left" }}>Add A Title:</div>
          <input
            type="text"
            name='puzzle-name-input'
            placeholder={`This will not be visible to ${puzzleType} players`}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        {puzzleType === "quiz" ? (
          <div className="input-labels-container">
            <div style={{ textAlign: "left" }}>How many questions would you like? :</div>
            <select name="questions" id="questions-select" onChange={e => setQuestions(e.target.value)} > 
              {questionOptions.map((i) => (
                <option
                  value={i}
                >
                  {i}
                </option>
              ))}
            </select>
          </div>
        ) : null}

        <div
          className="content-text-label-container"
          style={{ textAlign: "left" }}
        >
          <div>Add Content Text (We will use this to generate your {puzzleType}):</div>
          {!isValidContentLength ? (
            <div className="validation-warning-text">
              Reduce Content Text by {tokensOver}
            </div>
          ) : null}
        </div>
        <textarea
          type="text"
          name='puzzle-context-text'
          placeholder="Just copy/pate your content source text here"
          value={contentText}
          onChange={(e) => setContentText(e.target.value)}
        />
        <div
          className={`submit-puzzle-text-button ${
            !isValidContentLength ? "disabled" : ""
          }`}
          name='submit-puzzle-text-button'
          onClick={submitDynamicCrosswordText}
          disabled={!isValidContentLength}
        >
          Generate {GAMES_LABELS[puzzleType.toUpperCase()]}!
        </div>
      </div>
    </div>
  );
};

export default CollectContentForm;
